module.exports = __webpack_public_path__ + "static/media/designer_icon.fc995e87.png";